import RpcClass from "../../../../../../server/RpcClass.js";


import RpcNotFoundException from "../../../../../../server/com/silkplm/engine/rpc/exceptions/RpcNotFoundException.js";

let locale;
if(typeof window !== "undefined") {
    locale = window?.navigator?.userLanguage || window?.navigator?.language || Intl.DateTimeFormat().resolvedOptions().locale;
} else {
    locale= RpcClass.locale = Intl.DateTimeFormat().resolvedOptions().locale;
}

const FULL_CLASS = 'com.silkplm.rpc.plm.services.OrderDetailsService';

import LocalDate from "../../../../../../server/LocalDate.js";
import LocalDateTime from "../../../../../../server/LocalDateTime.js";
import LocalTime from "../../../../../../server/LocalTime.js";



class OrderDetailsService extends RpcClass{

    /**
     *  @class OrderDetailsService
     *  @alias module:src/server/com/silkplm/rpc/plm/services/OrderDetailsService.OrderDetailsService
     *  
     * */
    constructor(){
        super();


    }






    /** 
     * @async
     * @param orderDetailsList {module:src/server/com/silkplm/model/plm/OrderDetails.OrderDetails[]} 
     * @throws {module:src/server/com/silkplm/engine/rpc/exceptions/RpcInternalException.RpcInternalException}
     * @returns {Promise<*>}
     */
     addOrderDetailsAfterSelectOnPlanners(orderDetailsList) {
            return RpcClass.rpcCall('/rpc/plm/services/order-details-service/add-order-details-after-select-on-planners', [orderDetailsList]);
    }
    /** 
     * @async
     * @throws {module:src/server/com/silkplm/engine/rpc/exceptions/RpcInternalException.RpcInternalException}
     * @returns {Promise<boolean>}
     */
     checkIfIsLocalhost() {
            return RpcClass.rpcCall('/rpc/plm/services/order-details-service/check-if-is-localhost', []);
    }
    /** 
     * @async
     * @param orderDetails {module:src/server/com/silkplm/model/plm/OrderDetails.OrderDetails} 
     * @throws {module:src/server/com/silkplm/engine/rpc/exceptions/RpcInternalException.RpcInternalException}
     * @returns {Promise<boolean>}
     */
     checkIfOrderIsAlreadyIntegratedWithExternalSystem(orderDetails) {
            return RpcClass.rpcCall('/rpc/plm/services/order-details-service/check-if-order-is-already-integrated-with-external-system', [orderDetails]);
    }
    /** 
     * @async
     * @param selection {module:src/server/com/silkplm/rpc/dto/StreamSelection.StreamSelection} 
     * @throws {module:src/server/com/silkplm/engine/rpc/exceptions/RpcInternalException.RpcInternalException}
     * @returns {Promise<Object.<string, string>>}
     */
     computedSummaryValuesToOrderDetailsList(selection) {
            return RpcClass.rpcCall('/rpc/plm/services/order-details-service/computed-summary-values-to-order-details-list', [selection]);
    }
    /** 
     * @async
     * @param orderDetailsList {module:src/server/com/silkplm/model/plm/OrderDetails.OrderDetails[]} 
     * @throws {module:src/server/com/silkplm/engine/rpc/exceptions/RpcInternalException.RpcInternalException}
     * @returns {Promise<*>}
     */
     deleteOrderDetails(orderDetailsList) {
            return RpcClass.rpcCall('/rpc/plm/services/order-details-service/delete-order-details', [orderDetailsList]);
    }
    /** 
     * @async
     * @throws {module:src/server/com/silkplm/engine/rpc/exceptions/RpcInternalException.RpcInternalException}
     * @returns {Promise<module:src/server/com/silkplm/model/plm/dictionaries/OrderDetailsShipmentStatus.OrderDetailsShipmentStatus>}
     */
     findInProductionShipmentSampleStatus() {
            return RpcClass.rpcCall('/rpc/plm/services/order-details-service/find-in-production-shipment-sample-status', []);
    }
    /** 
     * @async
     * @param orderId {string} 
     * @param productInSeasonId {string} 
     * @throws {module:src/server/com/silkplm/engine/rpc/exceptions/RpcInternalException.RpcInternalException}
     * @returns {Promise<string>}
     */
     findPackagingProductStatus(orderId, productInSeasonId) {
            return RpcClass.rpcCall('/rpc/plm/services/order-details-service/find-packaging-product-status', [orderId, productInSeasonId]);
    }
    /** 
     * @async
     * @param orderId {string} 
     * @param productInSeasonId {string} 
     * @throws {module:src/server/com/silkplm/engine/rpc/exceptions/RpcInternalException.RpcInternalException}
     * @returns {Promise<string>}
     */
     findPpSampleStatus(orderId, productInSeasonId) {
            return RpcClass.rpcCall('/rpc/plm/services/order-details-service/find-pp-sample-status', [orderId, productInSeasonId]);
    }
    /** 
     * @async
     * @param orderDetails {module:src/server/com/silkplm/model/plm/OrderDetails.OrderDetails} 
     * @throws {module:src/server/com/silkplm/engine/rpc/exceptions/RpcInternalException.RpcInternalException}
     * @returns {Promise<string>}
     */
     findRemarksForProductInSeason(orderDetails) {
            return RpcClass.rpcCall('/rpc/plm/services/order-details-service/find-remarks-for-product-in-season', [orderDetails]);
    }
    /** 
     * @async
     * @param productSeasonId {string} 
     * @throws {module:src/server/com/silkplm/engine/rpc/exceptions/RpcInternalException.RpcInternalException}
     * @returns {Promise<string>}
     */
     findRemarksForProductInSeasonInPreviousSeason(productSeasonId) {
            return RpcClass.rpcCall('/rpc/plm/services/order-details-service/find-remarks-for-product-in-season-in-previous-season', [productSeasonId]);
    }
    /** 
     * @async
     * @param orderDetails {module:src/server/com/silkplm/model/plm/OrderDetails.OrderDetails} 
     * @throws {module:src/server/com/silkplm/engine/rpc/exceptions/RpcInternalException.RpcInternalException}
     * @returns {Promise<number>}
     */
     findRequiredTestReportStatus(orderDetails) {
            return RpcClass.rpcCall('/rpc/plm/services/order-details-service/find-required-test-report-status', [orderDetails]);
    }
    /** 
     * @async
     * @param productInSeasonId {string} 
     * @throws {module:src/server/com/silkplm/engine/rpc/exceptions/RpcInternalException.RpcInternalException}
     * @returns {Promise<boolean>}
     */
     findSanepid(productInSeasonId) {
            return RpcClass.rpcCall('/rpc/plm/services/order-details-service/find-sanepid', [productInSeasonId]);
    }
    /** 
     * @async
     * @param orderId {string} 
     * @param productInSeasonId {string} 
     * @throws {module:src/server/com/silkplm/engine/rpc/exceptions/RpcInternalException.RpcInternalException}
     * @returns {Promise<string>}
     */
     findShipmentSampleStatus(orderId, productInSeasonId) {
            return RpcClass.rpcCall('/rpc/plm/services/order-details-service/find-shipment-sample-status', [orderId, productInSeasonId]);
    }
    /** 
     * @async
     * @param orderDetails {module:src/server/com/silkplm/model/plm/OrderDetails.OrderDetails} 
     * @throws {module:src/server/com/silkplm/engine/rpc/exceptions/RpcInternalException.RpcInternalException}
     * @returns {Promise<string>}
     */
     findStickerWCLStatus(orderDetails) {
            return RpcClass.rpcCall('/rpc/plm/services/order-details-service/find-sticker-w-c-l-status', [orderDetails]);
    }
    /** 
     * @async
     * @param supplierId {string} 
     * @param seasonId {string} 
     * @param merchantId {string} 
     * @param PM {string} 
     * @throws {module:src/server/com/silkplm/engine/rpc/exceptions/RpcInternalException.RpcInternalException}
     * @returns {Promise<module:src/server/com/silkplm/model/plm/ColorVersionBindingPlanning.ColorVersionBindingPlanning[]>}
     */
     getAllColorVersionBindingPlanningConfirmedForEveryUser(supplierId, seasonId, merchantId, PM) {
            return RpcClass.rpcCall('/rpc/plm/services/order-details-service/get-all-color-version-binding-planning-confirmed-for-every-user', [supplierId, seasonId, merchantId, PM]);
    }
    /** 
     * @async
     * @param supplierId {string} 
     * @param seasonId {string} 
     * @param merchantId {string} 
     * @param PM {string} 
     * @throws {module:src/server/com/silkplm/engine/rpc/exceptions/RpcInternalException.RpcInternalException}
     * @returns {Promise<module:src/server/com/silkplm/model/plm/ColorVersionBindingPlanning.ColorVersionBindingPlanning[]>}
     */
     getAllColorVersionsBindingsPlaningWithConfirmedStatus(supplierId, seasonId, merchantId, PM) {
            return RpcClass.rpcCall('/rpc/plm/services/order-details-service/get-all-color-versions-bindings-planing-with-confirmed-status', [supplierId, seasonId, merchantId, PM]);
    }


    /** @returns {string} */
    getRemoteClass(){
        return FULL_CLASS;
    }
}



let metadata = {};

metadata.__type__ = 'com.silkplm.rpc.plm.services.OrderDetailsService';
metadata.__type_short__ = 'OrderDetailsService';
OrderDetailsService.prototype.__metadata__ = metadata;

OrderDetailsService.prototype.__cls__ = FULL_CLASS;

/** @module src/server/com/silkplm/rpc/plm/services/OrderDetailsService */
export default OrderDetailsService

export { OrderDetailsService }
